import { SelectStatic } from "./SelectStatic"

interface DummyStaticSelectProps {
  onClick: () => void
  value: string
  placeholder: string
}

const DummyStaticSelect = ({ onClick, value, placeholder }: DummyStaticSelectProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent> | React.TouchEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    onClick()
  }

  return (
    <div onTouchEnd={handleClick} onClickCapture={handleClick}>
      <SelectStatic
        placeholder={placeholder}
        values={value ? [{ value: 1, label: value }] : []}
        skipOpeningDropdown
        isSearchable={false}
      />
    </div>
  )
}

export default DummyStaticSelect
